import { defineMessages } from 'react-intl';

export default defineMessages({
  error: 'Please input the correct amount',
  continue: 'Continue',
});
